import styled from "styled-components";

export const ProductWarrantyCreateContainerStyled = styled.div``;
